<template>
	<div class="_modal bg-white">
		<div
			class="_modal__content md-down:px-4 px-12 py-6 flex flex-col items-center justify-center"
		>
			<div>
				<img
					src="@/assets/images/illustrations/email_parent.svg"
					alt="Luca Education"
					title="Luca Education"
					height="150"
					width="150"
				/>
			</div>
			<div
				class="_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center"
			>
				{{
					survey ? 'Gửi phiếu khảo sát tới phụ huynh' : 'Gửi thực đơn'
				}}
			</div>
			<div class="w-full mt-5">
				<div class="input-group grid grid-cols-2 items-center mt-10">
					<div
						class="text-neutral-400 font-semibold text-xs uppercase"
					>
						{{ survey ? 'Tên phiếu khảo sát' : 'Nội dung' }}
					</div>
					<div class="text-neutral-700">
						{{ notification.title }}
					</div>
				</div>
				<div class="input-group grid grid-cols-2 items-center mt-10">
					<div
						class="text-neutral-400 font-semibold text-xs uppercase"
					>
						ĐỐI TƯỢNG
					</div>
					<div
						class="text-neutral-700"
						v-if="
							typeof notification.subject === 'object' &&
							notification.subject.length > 0
						"
					>
						<div
							v-for="subject in notification.subject"
							:key="subject"
						>
							{{ subject }}
						</div>
					</div>
					<div class="text-neutral-700" v-else>
						{{ notification.subject }}
					</div>
				</div>
				<div class="input-group grid grid-cols-2 items-center mt-10">
					<div
						class="text-neutral-400 font-semibold text-xs uppercase"
					>
						người gửi
					</div>
					<div class="text-neutral-700">
						{{ notification.sender }}
					</div>
				</div>
			</div>
		</div>
		<div
			class="_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center"
		>
			<button
				type="button"
				class="button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700"
				@click="$emit('close')"
			>
				Quay lại
			</button>
			<button
				type="button"
				class="button-p text-center whitespace-nowrap"
				@click="$emit('submit')"
			>
				Xác nhận
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ConfirmSend',

	props: {
		notification: {
			type: Object,
			required: true,
		},
		survey: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
};
</script>
